import React from 'react';
import { connect, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Fund } from 'src/components/Exchange/types';
import { getSelectedBank } from 'src/redux/modules/bankSelection/bankSelection.selectors';
import { getDisplayTradeDate } from 'src/redux/modules/funds/UserFunds/userFunds.selectors';
import {
  openModal as openModalAction,
  PAPERLESS_TERMS_MODAL,
} from 'src/redux/modules/modals/modals.module';
import { getDeliveryMethod } from 'src/redux/modules/sellDeliveryMethod/sellDeliveryMethod.selectors';
import {
  getFundsByAddressLookup,
  getHasMultipleNames,
  getIsEFT,
  getIsTakeHomeEstimated,
  getMultipleAddressFlag,
  getSelectedSellFundsList,
  getSellTakeHomeAmount,
  getSellTransactionDeductionTotal,
  getSellTransactionTotal,
} from 'src/redux/modules/sellTransaction/sellTransaction.selectors';
import {
  getHasUserInteracted,
  getShowPaperlessOptIn,
  getUpdatedPaperless,
} from 'src/redux/modules/user/Paperless/paperless.selectors';
import {
  paperlessInteraction as paperlessInteractionAction,
  updatePaperlessSetting as updatePaperlessAction,
} from 'src/redux/modules/user/Paperless/paperlessSetting.module';
import {
  getHasUserEmail,
  getUserAddress,
} from 'src/redux/modules/user/PersonalInformation/personalInformation.selectors';
import { DELIVERY_MAIL_CHECK, DELIVERY_IN_KIND } from 'src/settings/settings';
import { isCollegeDistribute, isAppSell } from 'src/utils/transactions-util';
import PaperlessOptIn from '../../Buy/BuyFlow/PaperlessOptIn/PaperlessOptIn';
import CollegeDistributeDisclaimerNote from '../../CollegeDistribute/CollegeDistributeDisclaimerNote/CollegeDistributeDisclaimerNote';
import If from '../../Shared/If/If';
import StepExpanded from '../../Shared/StepExpanded/StepExpanded';
import SellMultipleAddressReview from './SellMultipleAddressReview/SellMultipleAddressReview';
import './SellReview.scss';
import SellTransactionsReview from './SellTransactionsReview/SellTransactionsReview';
import {
  isCustomerWebViewEnabled,
  isSalesforceRep,
} from 'src/redux/modules/authentication/authentication.module.selectors';

// TODO-College distribute flow has been broken into its own component. Checks for isCollegeDistribute can be
// safely removed from this component.
const SellReview = ({
  openModal,
  paperlessInteraction,
  updatePaperlessSetting,
}) => {
  const customerWebViewEnabled: boolean = useSelector(isCustomerWebViewEnabled);
  const isSalesforceRepEnabled: boolean = useSelector(isSalesforceRep);
  const address = useSelector(getUserAddress);
  const deliveryMethod = useSelector(getDeliveryMethod);
  const displayTradeDate = useSelector(getDisplayTradeDate);
  const fundsByAddressLookup = useSelector(getFundsByAddressLookup);
  const hasMultipleNames = useSelector(getHasMultipleNames);
  const hasUserEmail = useSelector(getHasUserEmail);
  const hasUserInteracted = useSelector(getHasUserInteracted);
  const isEFT = useSelector(getIsEFT);
  const isTakeHomeEstimated = useSelector(getIsTakeHomeEstimated);
  const multipleAddressFlag = useSelector(getMultipleAddressFlag);
  const selectedBank = useSelector(getSelectedBank);
  const selectedFunds: Fund[] = useSelector(getSelectedSellFundsList);
  const sellTakeHomeAmount = useSelector(getSellTakeHomeAmount);
  const sellTotalAmount = useSelector(getSellTransactionTotal);
  const sellTotalDeduction = useSelector(getSellTransactionDeductionTotal);
  const showPaperlessOptIn = useSelector(getShowPaperlessOptIn);
  const updatedPaperless = useSelector(getUpdatedPaperless);
  return (
    <StepExpanded>
      <div className="sell-review">
        <div className="row hidden-xs sell-review-heading">
          <div className="col-md-5 col-sm-6 sell-review-delivery">
            DELIVERY METHOD
          </div>
          <div className="col-md-5 col-sm-6">FROM</div>
          <div className="col-md-2 hidden-sm sell-review-amount">AMOUNT</div>
        </div>
        <If
          test={
            isEFT ||
            deliveryMethod === DELIVERY_IN_KIND ||
            (deliveryMethod === DELIVERY_MAIL_CHECK && !multipleAddressFlag)
          }
        >
          <SellTransactionsReview
            address={address}
            deliveryMethod={deliveryMethod}
            displayTradeDate={displayTradeDate}
            hasMultipleNames={hasMultipleNames}
            isEFT={isEFT}
            isTakeHomeEstimated={isTakeHomeEstimated}
            multipleAddressFlag={multipleAddressFlag}
            selectedBank={selectedBank}
            selectedFunds={selectedFunds}
            sellTakeHomeAmount={sellTakeHomeAmount}
            sellTotalAmount={sellTotalAmount}
            sellTotalDeduction={sellTotalDeduction}
          />
        </If>
        <If
          test={deliveryMethod === DELIVERY_MAIL_CHECK && multipleAddressFlag}
        >
          <SellMultipleAddressReview
            deliveryMethod={deliveryMethod}
            displayTradeDate={displayTradeDate}
            fundsByAddressLookup={fundsByAddressLookup}
          />
        </If>
        <If test={isCollegeDistribute()}>
          <CollegeDistributeDisclaimerNote
            selectedProductTypes={selectedFunds.map((fund) => fund.productType)}
          />
        </If>
      </div>
      <If
        test={
          !isCollegeDistribute() &&
          !isAppSell() &&
          hasUserEmail &&
          showPaperlessOptIn &&
          !(!customerWebViewEnabled && isSalesforceRepEnabled)
        }
      >
        <PaperlessOptIn
          openModal={openModal}
          paperlessChecked={updatedPaperless}
          updatePaperlessChecked={(checkValue) => {
            if (!hasUserInteracted) {
              paperlessInteraction();
              openModal(PAPERLESS_TERMS_MODAL);
            }
            updatePaperlessSetting(checkValue);
          }}
        />
      </If>
    </StepExpanded>
  );
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      openModal: openModalAction,
      updatePaperlessSetting: updatePaperlessAction,
      paperlessInteraction: paperlessInteractionAction,
    },
    dispatch
  );

export default connect(null, mapDispatchToProps)(SellReview);
